// actions/departmentActions.js
// BUG FIX: this used a standalone axios instance (cookie-only auth),
// unlike the rest of the app's action files which use createApi() from
// utils/apiClient — that shared client also attaches the JWT as a
// Bearer header from localStorage, which is what makes auth work inside
// Capacitor (mobile) and Electron, where cross-origin cookies are
// unreliable/don't persist. Without it, every call in this file would
// silently 401 on mobile/desktop (web was fine, since cookies work
// there).
import createApi from "../utils/apiClient";
const api = createApi();

export const getAllDepartments =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "ALL_DEPARTMENTS_REQUEST" });
      const { data } = await api.get("/departments", { params });
      dispatch({ type: "ALL_DEPARTMENTS_SUCCESS", payload: data.departments });
    } catch (err) {
      dispatch({
        type: "ALL_DEPARTMENTS_FAIL",
        payload: err.response?.data?.message,
      });
    }
  };

// Admin "Pending Approval" tab
export const getPendingDepartments = () => async (dispatch) => {
  try {
    dispatch({ type: "PENDING_DEPARTMENTS_REQUEST" });
    const { data } = await api.get("/departments/pending");
    dispatch({
      type: "PENDING_DEPARTMENTS_SUCCESS",
      payload: data.departments,
    });
  } catch (err) {
    dispatch({
      type: "PENDING_DEPARTMENTS_FAIL",
      payload: err.response?.data?.message,
    });
  }
};

export const createDepartment = (payload) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_DEPARTMENT_REQUEST" });
    const { data } = await api.post("/departments", payload);
    dispatch({ type: "CREATE_DEPARTMENT_SUCCESS", payload: data.department });
    return data;
  } catch (err) {
    dispatch({
      type: "CREATE_DEPARTMENT_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// Called from the Add Staff form's "+ type a new value" option.
// Saves as "pending" — does NOT show up in dropdowns until approved.
export const suggestDepartment = (name, parent_id) => async (dispatch) => {
  try {
    dispatch({ type: "SUGGEST_DEPARTMENT_REQUEST" });
    const { data } = await api.post("/departments/suggest", {
      name,
      parent_id,
    });
    dispatch({ type: "SUGGEST_DEPARTMENT_SUCCESS", payload: data.department });
    return data;
  } catch (err) {
    dispatch({
      type: "SUGGEST_DEPARTMENT_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const approveDepartment = (id) => async (dispatch) => {
  try {
    const { data } = await api.put(`/departments/${id}/approve`);
    dispatch({ type: "APPROVE_DEPARTMENT_SUCCESS", payload: data.department });
    return data;
  } catch (err) {
    dispatch({
      type: "APPROVE_DEPARTMENT_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const rejectDepartment = (id, reason) => async (dispatch) => {
  try {
    const { data } = await api.put(`/departments/${id}/reject`, { reason });
    dispatch({ type: "REJECT_DEPARTMENT_SUCCESS", payload: data.department });
    return data;
  } catch (err) {
    dispatch({
      type: "REJECT_DEPARTMENT_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const updateDepartment = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_DEPARTMENT_REQUEST" });
    const { data } = await api.put(`/departments/${id}`, payload);
    dispatch({ type: "UPDATE_DEPARTMENT_SUCCESS", payload: data.department });
    return data;
  } catch (err) {
    dispatch({
      type: "UPDATE_DEPARTMENT_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const deleteDepartment = (id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_DEPARTMENT_REQUEST" });
    const { data } = await api.delete(`/departments/${id}`);
    dispatch({ type: "DELETE_DEPARTMENT_SUCCESS", payload: id });
    return data;
  } catch (err) {
    dispatch({
      type: "DELETE_DEPARTMENT_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// A rejected entry can be resubmitted — resets it back to "pending" so it
// shows up in the Approvals queue again.
export const resubmitDepartment = (id) => async (dispatch) => {
  try {
    const { data } = await api.put(`/departments/${id}/resubmit`);
    dispatch({ type: "RESUBMIT_DEPARTMENT_SUCCESS", payload: data.department });
    return data;
  } catch (err) {
    dispatch({
      type: "RESUBMIT_DEPARTMENT_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// Rejected list — shown on the Approvals page so admin/requester can
// review the reason and Resubmit if needed. Stored separately from the
// active dropdown list (state.department.rejected) to avoid clobbering it.
export const getRejectedDepartments = () => async (dispatch) => {
  try {
    const { data } = await api.get("/departments", {
      params: { status: "rejected" },
    });
    dispatch({
      type: "REJECTED_DEPARTMENTS_SUCCESS",
      payload: data.departments,
    });
  } catch (err) {
    dispatch({
      type: "REJECTED_DEPARTMENTS_FAIL",
      payload: err.response?.data?.message,
    });
  }
};
